import React from "react";
import { useParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import ViewEInvoice from "../../../components/sales-section/e-invoice/view-e-invoice";

const ViewEInvoicePage = () => {
  const { id } = useParams();

  return (
    <InnerLayout backBtn={true} title="e-Invoice">
      <ViewEInvoice invoiceId={id} />
    </InnerLayout>
  );
};

export default ViewEInvoicePage;
